import type { FilterExtraFieldReturn } from './filter-extra-field.hook'

import { useFilterExtraField } from './filter-extra-field.hook'

interface FilterAlertTypeOptions {
  initial: string[]
}

export const useFilterAlertType = ({ initial }: FilterAlertTypeOptions): FilterExtraFieldReturn => {
  return useFilterExtraField({ name: 'alert_type', initial })
}
